import { NavItemType } from '../types/menu';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as DashboardIcon } from '../assets/images/icons/sidebar/dashboard.svg';
import { ReactComponent as CopierEngineIcon } from '../assets/images/icons/sidebar/copier-engine.svg';
import { ReactComponent as LogsIcon } from '../assets/images/icons/sidebar/logs.svg';
import { ReactComponent as CopierTemplatesIcon } from '../assets/images/icons/sidebar/template.svg';
import { ReactComponent as RoomsIcon } from '../assets/images/icons/sidebar/rooms.svg';
import { ReactComponent as PerformanceIcon } from '../assets/images/icons/sidebar/performance.svg';
import { ReactComponent as PortfolioIcon } from '../assets/images/icons/sidebar/portfolio.svg';
import { ReactComponent as AnalysisHubIcon } from '../assets/images/icons/sidebar/analysis-hub.svg';
// import { ReactComponent as LiveDetectorIcon } from '../assets/images/icons/sidebar/live-detector.svg';
// import { ReactComponent as SocialHubIcon } from '../assets/images/icons/sidebar/social-hub.svg';
// import { ReactComponent as LeaderboardIcon } from '../assets/images/icons/sidebar/leaderboard.svg';
import { ReactComponent as MarketNewsIcon } from '../assets/images/icons/sidebar/market-news.svg';
import { ReactComponent as EconomicCalendarIcon } from '../assets/images/icons/sidebar/economic-calendar.svg';
import { ReactComponent as SentimentsIcon } from '../assets/images/icons/sidebar/sentiments.svg';
// import { ReactComponent as BrokerComparisonIcon } from '../assets/images/icons/sidebar/broker-comparison.svg';
// import { ReactComponent as PropComparisonIcon } from '../assets/images/icons/sidebar/prop-comparison.svg';
import { ReactComponent as AffiliateIcon } from '../assets/images/icons/sidebar/affiliate.svg';
import { ReactComponent as BillingIcon } from '../assets/images/icons/sidebar/billing.svg';
import { ReactComponent as AccountConfigurationIcon } from '../assets/images/icons/sidebar/account-configuration.svg';
import { ReactComponent as AccountTradesIcon } from '../assets/images/icons/account-trades.svg';
import { ReactComponent as IntegrationsIcon } from '../assets/images/icons/integrations.svg';
import { ApiOutlined, BulbOutlined, ClusterOutlined } from '@ant-design/icons';

// GENERAL group
export const getGeneralGroup = (isFreeUser: boolean = false): NavItemType => ({
  id: 'general-group',
  title: <FormattedMessage id="general" />,
  type: 'group',
  breadcrumbs: false,
  children: [
    {
      icon: DashboardIcon,
      id: 'dashboard',
      title: <FormattedMessage id="dashboard" />,
      type: 'item',
      url: '/dashboard',
      breadcrumbs: false
    },
    {
      id: 'account-configuration',
      title: <FormattedMessage id="account-configuration" />,
      icon: AccountConfigurationIcon,
      type: 'item',
      breadcrumbs: false,
      url: '/accounts'
    },
    {
      id: 'account-trades',
      title: <FormattedMessage id="account-trades" />,
      icon: AccountTradesIcon,
      type: 'item',
      breadcrumbs: false,
      url: '/account-trades',
      isFreeUserLocked: isFreeUser
    }
    /*{
      icon: DeploymentUnitOutlined,
      id: 'integrations',
      title: <FormattedMessage id="integrations" />,
      type: 'item',
      url: '/integration',
      breadcrumbs: false
    }*/
  ]
});

// TC COPIER group
export const getTcCopierGroup = (isFreeUser: boolean = false): NavItemType => ({
  id: 'tc-copier-group',
  title: <FormattedMessage id="tc-copier" />,
  type: 'group',
  breadcrumbs: false,
  children: [
    {
      id: 'copier-engine',
      title: <FormattedMessage id="copier-engine" />,
      icon: CopierEngineIcon,
      type: 'item',
      breadcrumbs: false,
      url: '/trade-copier/copier-settings',
      isFreeUserLocked: isFreeUser
    },
    {
      id: 'copier-templates',
      title: <FormattedMessage id="copier-templates" />,
      icon: CopierTemplatesIcon,
      type: 'item',
      breadcrumbs: false,
      url: '/trade-copier/templates',
      isFreeUserLocked: isFreeUser
    },
    {
      id: 'copier-logs',
      title: <FormattedMessage id="copier-logs" />,
      icon: LogsIcon,
      type: 'item',
      breadcrumbs: false,
      url: '/trade-copier/copier-logs',
      isFreeUserLocked: isFreeUser
    },
    // Rooms (Signal Manager) is its own subscription, so free users may buy one too.
    {
      id: 'rooms',
      title: <FormattedMessage id="rooms" defaultMessage="Rooms" />,
      icon: RoomsIcon,
      type: 'item',
      breadcrumbs: false,
      url: '/trade-copier/rooms'
    }
  ]
});

// TC ANALYZER group
export const getTcAnalyzerGroup = (hasAnalyzerRole: boolean = false): NavItemType => ({
  id: 'tc-analyzer-group',
  title: <FormattedMessage id="tc-analyzer" />,
  // Badged at the group, not on each of the three items — it describes the
  // product's maturity, and repeating it three times reads as three separate
  // early-access features.
  chip: { label: 'EARLY ACCESS', color: 'primary', size: 'small', variant: 'outlined' },
  type: 'group',
  breadcrumbs: false,
  children: [
    {
      id: 'performance',
      title: <FormattedMessage id="performance" />,
      icon: PerformanceIcon,
      type: 'item',
      breadcrumbs: false,
      url: '/analyzer/performance',
      isAnalyzerLocked: !hasAnalyzerRole
    },
    {
      id: 'portfolio',
      title: <FormattedMessage id="portfolio" />,
      icon: PortfolioIcon,
      type: 'item',
      breadcrumbs: false,
      url: '/analyzer/portfolio',
      isAnalyzerLocked: !hasAnalyzerRole
    },
    {
      id: 'analysis-hub',
      title: <FormattedMessage id="analysis-hub" />,
      icon: AnalysisHubIcon,
      type: 'item',
      breadcrumbs: false,
      url: '/analyzer/analysis-hub',
      isAnalyzerLocked: !hasAnalyzerRole
    }
    // {
    //   id: 'live-detector',
    //   title: <FormattedMessage id="live-detector" />,
    //   icon: LiveDetectorIcon,
    //   type: 'item',
    //   breadcrumbs: false,
    //   url: '/analyzer/live-detector'
    // },
    // {
    //   id: 'social-hub',
    //   title: <FormattedMessage id="social-hub" />,
    //   icon: SocialHubIcon,
    //   type: 'item',
    //   breadcrumbs: false,
    //   url: '/analyzer/social-hub'
    // },
    // {
    //   id: 'leaderboard',
    //   title: <FormattedMessage id="leaderboard" />,
    //   icon: LeaderboardIcon,
    //   type: 'item',
    //   breadcrumbs: false,
    //   url: '/analyzer/leaderboard'
    // }
  ]
});

// TRADING TOOLS group
export const getTradingToolsGroup = (isFreeUser: boolean = false, canSeeAiConnect: boolean = false): NavItemType => ({
  id: 'trading-tools-group',
  title: <FormattedMessage id="trading-tools" />,
  type: 'group',
  breadcrumbs: false,
  children: [
    // AI Connect — concealed during the controlled rollout, shown only to users
    // granted the "MCP User" role in Auth0 (utils/mcp canSeeMcp). At launch,
    // MCP_PUBLIC_LAUNCH flips and this renders for everyone.
    ...(canSeeAiConnect
      ? ([
          {
            id: 'mcp',
            title: 'AI Connect',
            // the connector/plug glyph — MCP is a connector, and this keeps the
            // Analysis Hub icon from appearing twice in the sidebar
            icon: ApiOutlined,
            type: 'item',
            breadcrumbs: false,
            url: '/ai-connect',
            // Beta while the rollout is role-limited — sets expectations for the
            // testers who are the only ones who can see this at all.
            chip: { label: 'BETA', color: 'primary', size: 'small', variant: 'outlined' }
          }
        ] as NavItemType[])
      : []),
    {
      id: 'market-news',
      title: <FormattedMessage id="market-news" />,
      icon: MarketNewsIcon,
      type: 'item',
      breadcrumbs: false,
      url: '/tools/market-news',
    },
    {
      id: 'economic-calendar',
      title: <FormattedMessage id="economic-calendar" />,
      icon: EconomicCalendarIcon,
      type: 'item',
      breadcrumbs: false,
      url: '/economic-calendar',
    },
    {
      id: 'sentiments',
      title: <FormattedMessage id="sentiments" />,
      icon: SentimentsIcon,
      type: 'item',
      breadcrumbs: false,
      url: '/sentiments',
    },
    {
      id: 'integration',
      title: <FormattedMessage id="integrations" />,
      icon: IntegrationsIcon,
      type: 'item',
      breadcrumbs: false,
      url: '/integration',
    }
  ]
});

// COMPARE group
// export const compareGroup: NavItemType = {
//   id: 'compare-group',
//   title: <FormattedMessage id="compare" />,
//   type: 'group',
//   breadcrumbs: false,
//   children: [
//     {
//       id: 'broker-comparison',
//       title: <FormattedMessage id="broker-comparison" />,
//       icon: BrokerComparisonIcon,
//       type: 'item',
//       breadcrumbs: false,
//       url: '/compare/broker-comparison'
//     },
//     {
//       id: 'prop-comparison',
//       title: <FormattedMessage id="prop-comparison" />,
//       icon: PropComparisonIcon,
//       type: 'item',
//       breadcrumbs: false,
//       url: '/compare/prop-comparison'
//     }
//   ]
// };

// EA CONNECT group
export const getEaConnectGroup = (): NavItemType => ({
  id: 'ea-connect-group',
  title: <FormattedMessage id="ea-connect" />,
  type: 'group',
  breadcrumbs: false,
  children: [
    // ONE destination: the fleet console. Deploying is an action started from
    // the fleet (button, ghost slot row, or the empty-state dropzone) — not a
    // second place to live; /ea-connect/deploy stays routable but unlisted.
    {
      id: 'my-bots',
      title: <FormattedMessage id="my-bots" />,
      type: 'item',
      url: '/ea-connect/fleet',
      icon: ClusterOutlined,
      breadcrumbs: false
    }
  ]
});

// FEEDBACK group
export const feedbackGroup: NavItemType = {
  id: 'feedback-group',
  title: <FormattedMessage id="feedback" />,
  type: 'group',
  breadcrumbs: false,
  children: [
    {
      id: 'feature-requests',
      title: <FormattedMessage id="feature-requests" />,
      icon: BulbOutlined,
      type: 'item',
      breadcrumbs: false,
      url: '/feature-requests'
    }
  ]
};

// GROWTH & MONETIZATION group
export const growthMonetizationGroup: NavItemType = {
  id: 'growth-monetization-group',
  title: <FormattedMessage id="growth-monetization" />,
  type: 'group',
  breadcrumbs: false,
  children: [
    {
      id: 'affiliate',
      title: <FormattedMessage id="affiliate" />,
      icon: AffiliateIcon,
      type: 'item',
      breadcrumbs: false,
      url: 'https://affiliates.tradersconnect.com',
      target: true
    },
    {
      id: 'billing',
      title: <FormattedMessage id="billing" />,
      icon: BillingIcon,
      type: 'item',
      breadcrumbs: false,
      url: '/account-settings/billing'
    }
  ]
};
